(function ($, global) {

  /**
   * Вспомогательные функции реквизита выбора объекта.
   * @since 5.5.0.1000
   */
  var BaseSelectRequisite = Class.extend({
    className: 'BaseSelectRequisite',

    _jInput: null,

    // ИД поля компоненты.
    controlId: '',
    // Страница для проверки в парсинге ссылок. doc.asp или reference.asp
    linkPageName: '',
    // Множественный выбор или нет.
    isMultiSelect: false,

    // Конструктор.
    init: function (options) {
      var me = this;
      $.extend(me, options);

      if ($("input#" + me.controlId).length) {
        me._initControl();
      } else
        $(function () {
          setTimeout(me._initControl.bind(me), 0);
        });
    },

    _initControl: function () {
      var me = this;

      me._jInput = $("input#" + me.controlId);
      me._jHidden = $('#hSelID_' + me.controlId);

      me._bindOnPaste();
    },

    // Инициализирует компоненту.
    _bindOnPaste: function () {
      var me = this;
      me._jInput.on('paste', me._onPaste.bind(me));
    },

    // Обработка вставки ссылки.
    _onPaste: function (event) {
      var me = this;

      var clipboardData = event.originalEvent.clipboardData || window.clipboardData;
      var pastedData = clipboardData.getData('text');

      if (pastedData) {
        var links = me._parsePastedDataAndGetLinks(pastedData);
        if (links && links.length > 0) {
          me._loadExtendedDataForLinks(links).done(function (extendedLinks) {
            me._setValueByLinks(extendedLinks);
          }).fail(function (err) {
            // Если нет прав или какая-то ошибка, просто вставим в поле текст из буфера (так в билдере).
            me._jInput.val(pastedData);
          });
        } else {
          // Если нет ссылок, просто вставим в поле текст из буфера.
          me._jInput.val(pastedData);
        }
      }

      event.preventDefault();      event.stopPropagation();    },

    // Загружает дополнительнные данные для ссылок. Например, наименование или ведущие реквизиты.
    _loadExtendedDataForLinks: function (links) {
      //Надо переопределять в потомках.
      var d = $.Deferred();
      d.resolve(links.map(function (link) {
        link.name = link.id;
        return link;
      }))
      return d.promise();
    },

    // Устанавливает значение в реквизиты выбора на основе распарсенных ссылок.
    _setValueByLinks: function (extendedLinks) {
      var me = this;
      if (me.isMultiSelect) {
        var values = extendedLinks.map(function (extendedLink) {
          return me._convertLinkToReferenceSelectValue(extendedLink);
        });
        me._jInput.SetValues(values, true);
      } else {
        me._jInput.SetValue(me._convertLinkToReferenceSelectValue(extendedLinks[0]), true);
      }
    },

    // Конвертирует ссылку в значение, которое принимает реквизиты выбора.
    _convertLinkToReferenceSelectValue: function (extendedLink) {
      //TODO Надо значения ведущих реквизитов.
      return [extendedLink.id, extendedLink.name.escapeHtml(), extendedLink.name, '{}'];
    },

    // Парсит текст, вставленный из буфера, и возвращает первую ссылку на объект.
    _parsePastedDataAndGetLinks: function (pastedData, isMultiSelect) {
      var me = this;
      var pastedLines = pastedData.split('\n');
      var links = [];
      for (var i = 0; i < pastedLines.length; i++) {
        var line = pastedLines[i];
        var link = me._parsePastedLine(line);
        if (link) {
          links.push(link);
          if (!isMultiSelect) {
            break;
          }
        }
      }
      return links;
    },

    // Парсит одну строку, вставленную из буфера.
    _parsePastedLine: function (line) {
      var me = this;
      var lineLowered = line.toLowerCase();

      me._webServerNameLowered = me._webServerNameLowered || g_WebServerName.toLowerCase();
      me._sysCodeLowered = me._sysCodeLowered || g_SysCode.toLowerCase();

      //NOTE Шамов А.: Не сделал регуляркой, потому что нужно экранировать спец.символы в _webServerNameLowered и _sysCodeLowered и она получается сложнее.

      if (lineLowered.indexOf(me._webServerNameLowered) !== -1 &&
          lineLowered.indexOf(me._sysCodeLowered) !== -1 &&
          lineLowered.indexOf('/' + me.linkPageName) !== -1) {
        return me._parseSuitableUrl(line);
      }
      return null;
    },

    // Парсинг подходящей строки в ссылку.
    _parseSuitableUrl: function (url) {
      //Надо переопределять в потомках.
      return null;
    },

  });

  global.BaseSelectRequisite = BaseSelectRequisite;

})(jQuery, window.Core.requisites);
